var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"offers"},[_c('Breadcrumbs',{attrs:{"breadcrumbs":_vm.breadcrumbs}}),_c('OffersTable',{attrs:{"isReadOnly":_vm.isReadOnly},on:{"create-offer":_vm.onCreateOffer,"edit-offer":_vm.onEditOffer}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }